import script from "./PermisosUsuario.vue?vue&type=script&lang=ts&setup=true"
export * from "./PermisosUsuario.vue?vue&type=script&lang=ts&setup=true"

import "./PermisosUsuario.vue?vue&type=style&index=0&id=7831db90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7831db90"]])

export default __exports__